import { HeatmapChart } from '../charts/HeatmapChart.tsx';
import { KpiTiles } from '../charts/KpiTiles.tsx';
import { Panel, ReportHeader } from '../components/Panel.tsx';

export function HeatmapReportPage() {
  return (
    <div className="space-y-6 w-full max-w-[1400px] mx-auto">
      <ReportHeader
        title="Stoßzeiten-Heatmap"
        desc="Wochentag × Stunde — wann ist am meisten los? Filter links eingrenzen (z. B. eine Filiale oder Region)."
      />
      <KpiTiles />
      <Panel title="Stoßzeiten" subtitle="Wochentag × Stunde · Farbintensität = Umsatz">
        <HeatmapChart />
      </Panel>
    </div>
  );
}
